<template>
  <div class="base-rating">
    <i
      v-for="n in Number(scale)"
      :key="n"
      :class="[
        'c-icon',
        icons[variation] ? icons[variation]['empty'] : icons['star']['empty'],
      ]"
    />

    <div
      class="icons-filled"
      :style="{
        width: ratingWidth + '%',
      }"
    >
      <i
        v-for="n in Number(scale)"
        :key="n"
        :class="[
          'c-icon',
          icons[variation]
            ? icons[variation]['filled']
            : icons['star']['filled'],
        ]"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseRating',

  props: {
    scale: {
      default: 10,
      type: [Number, String],
    },
    rating: {
      default: 7.8,
      type: [Number, String],
    },
    variation: {
      default: 'star',
      type: String,
    },
  },

  data: () => ({
    icons: {
      star: {
        filled: 'icon-star icon-filled',
        empty: 'icon-star-o icon-empty',
      },
      'star-rate': {
        filled: 'icon-star-rate',
        empty: 'icon-star-rate',
      },
      heart: {
        filled: 'icon-heart',
        empty: 'icon-heart-o',
      },
    },
  }),
  computed: {
    ratingWidth() {
      return (this.rating / this.scale) * 100;
    },
  },
};
</script>

<style lang="scss">
.base-rating {
  position: relative;
  display: inline-block;
  font-size: var(--size);

  i {
    margin-right: var(--spacing);
  }
}

.icons-filled {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
